module.exports = __webpack_public_path__ + "static/media/APOLLOTYRE_F1.e5f0e8a9.txt";